import $axios from '@src/_common/service/httpServer';

/**
 * 可以对$axios 进行适配当前项目的更改，覆盖原始方法
 * */

export default $axios;
